export default "__VITE_ASSET__CHVVA6Rp__"